// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: absolute;
  top: 50px;
  min-width: 150px;
  max-width: 245px;
  display: flex;
  visibility: hidden;
  opacity: 0;
  justify-content: flex-start;
  align-items: flex-start;
  transition: all 0.3s;
  background-color: rgba(55, 55, 55, 0.8);
  padding: 6px 8px;
  border-radius: 8px;
}
.wrapper span {
  position: relative;
  display: flex;
  width: 100%;
  font-size: 12px;
  line-height: 14.4px;
  font-weight: 500;
  color: #fff;
}
.wrapper span::before {
  position: absolute;
  top: -12px;
  left: calc(50% - 3px);
  display: block;
  content: "";
  width: 12px;
  height: 6px;
  background-color: rgba(55, 55, 55, 0.8);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}
.wrapper.hintVisible {
  visibility: visible;
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/Tabs/components/Hint/Hint.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,uBAAA;EACA,oBAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAIE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WCRI;ADMR;AAII;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,uCAAA;EACA,8CAAA;AAFN;AAME;EACE,mBAAA;EACA,UAAA;AAJJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
